<div class="alert" [ngClass]="tipo">
  {{ texto }}
</div>
